import styled from 'styled-components';
import { BsAsterisk } from 'react-icons/bs';
import { MdOutlineDragIndicator } from 'react-icons/md';
import { BodyText } from '@/utils/global-fonts';

const OptionMenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-item: flex-end;
  gap: 16px;
  width: auto;
`;
const MultiSingleLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  white-space: nowrap;
`;

const IsRequiredIcon = styled(BsAsterisk)`
  background-color: ${({ isRequired }) =>
    isRequired ? 'rgba(0, 0, 0, 1)' : 'rgba(234, 237, 243, 1)'};
  color: ${({ isRequired }) =>
    isRequired ? 'rgba(255, 255, 255, 1)' : 'rgba(88, 89, 91, 1)'};
  padding: 3px;
  font-size: 16px;
  border-radius: 50%;
`;

const MultiSingleLabel = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  font-size: 14px;
  width: auto;
  height: 24px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  gap: 4px;
  padding: 7px 11px;
`;

export const HasDependencies = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.COLOR_STATUS_TAG_BLUE_TEXT};
  background-color: ${({ theme }) => theme.COLOR_LIGHT_BLUE};
  font-size: 14px;
  width: auto;
  height: 24px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.COLOR_STATUS_TAG_BLUE_TEXT};
  gap: 4px;
  padding: 7px;
`;

const StickyMenuField = styled.div``;
export const styledOptionMenu = {
  Container: OptionMenuContainer,
  MultiSingleLabelWrapper,
  IsRequiredIcon,
  MultiSingleLabel,
  StickyMenuField,
};

const ProductOptionStyledInput = styled.input`
  flex: 1;
  border: none;
  margin: none;
  height: 48px;
  border-radius: none;
  box-shadow: none;
  padding: 16px 8px 16px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
`;

const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  height: 48px;
  width: 100%;
  padding-right: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GREY};
  .icon {
    font-size: 16px;
    color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  }
  .click {
    cursor: pointer;
  }
`;

const styledProductOptionForm = {
  ItemWrapper,
  StyledInput: ProductOptionStyledInput,
};

const OptionsNodeContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY3};
  padding: 10px;
  .isSelected {
    background: ${({ theme, isSelected }) =>
      isSelected ? theme.COLOR_GREY1 : ''};
    color: white;
    border-radius: 0;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;
const Arrow = styled.span`
  width: 20px;
  font-size: 20px;
  display: flex;
`;

const FileFolderIcon = styled.span`
  margin-right: 7px;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: ${({ theme }) => theme.COLOR_GREY3};
`;

const FileActions = styled.div`
  display: flex;
`;
const FolderFileActions = styled.div`
  display: flex;
  gap: 16px;
`;

const StyledInput = styled.input`
  flex: 1;
  border: none;
  margin: none;
  height: 48px;
  border-radius: none;
  box-shadow: none;
  padding: 16px 8px 16px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY3};
  border-left: none;
  border-right: none;
`;

const StickyButtonContainer = styled.div`
  position: relative;
  width: 190px;
`;

export const styledFolderStructure = {
  Container: OptionsNodeContainer,
  Content,
  Arrow,
  FileFolderIcon,
  FileActions,
  FolderFileActions,
  StickyButtonContainer,
  StyledInput,
};

const StyledBodyText = styled(BodyText)`
  text-align: center;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

const Container = styled.div`
  width: 100%;
`;

const ItemLabel = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  height: 24px;
  margin: 12px 0px 12px;
  padding-right: 24px;
  padding-left: ${(props) => (props?.indent ?? 1) * 15}px;
  .icon {
    font-size: 16px;
    color: ${({ theme }) => theme.COLOR_GREY_TEXT};
    transition: color 0.3s;
  }
  .icon:hover {
    color: ${({ theme }) => theme.COLOR_PRIMARY};
  }
`;
const FolderHeader = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GREY5};
`;
const Folder = styled.div`
  position: relative;
`;
const Option = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GREY5};
`;
const Separator = styled.hr`
  width: 100%;
  margin: 0;
`;

const OptionWrapper = styled.div`
  width: 100%;
  position: relative;
`;

const OptionCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  hr {
    margin: 0;
    padding: 0;
    border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  }
`;

const ItemIconAndTypeWrapper = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const ItemNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
`;

const AddNewOptionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  vertical-align: flex-end;
  cursor: pointer;
  width: 108px;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  border-radius: 4px;
  margin-top: 16px;
  margin-bottom: 8px;
  .arrow-icon {
    height: 100%;
    flex: 1;
  }
`;
const ButtonLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 60%;
  border-right: 1px solid ${({ theme }) => theme.COLOR_GREY5};
`;

const Wrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-bottom: none;
  width: 100%;
`;

const AddWrapper = styled.div`
  display: inline-block;
`;

const NoOptionAvailableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  text-align: center;
  margin: auto;
  margin: 50px 0;
`;
const NoOptionImg = styled.img``;

const FieldWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  align-items: center;
  flex-direction: row;
  gap: 2px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GREY5};
`;
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 500px;
  padding: 32px;
  padding-bottom: 40px;
`;
const ModalActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 500px;
  height: 79px;
  background-color: ${({ theme }) => theme.COLOR_GREY2};
  margin-bottom: none;
  padding: 32px;
`;

const OptionsFiles = styled.div`
  flex-grow: 1;
  min-block-size: 0;
`;
const TreeWrapper = styled.div`
  height: 500px;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

const DragHolder = styled.div`
  position: absolute;
  left: 2%;
`;

const ButtonContainer = styled.div``;

const Order = styled(MdOutlineDragIndicator)`
  cursor: pointer;
`;

const Span = styled.span`
  display: flex;
  width: 80%;
`;

export const styledOption = {
  Folder,
  DragHolder,
  Order,
  FolderHeader,
  Option,
  Container,
  Separator,
  OptionWrapper,
  OptionCol,
  ItemLabel,
  ItemIconAndTypeWrapper,
  ItemNameWrapper,
  AddNewOptionButton,
  ButtonLabelWrapper,
  Wrapper,
  NoOptionAvailableWrapper,
  NoOptionImg,
  StyledBodyText,
  StickyButtonContainer,
  FieldWrapper,
  ModalContent,
  ModalActionSection,
  TreeWrapper,
  OptionsFiles,
  ButtonContainer,
  AddWrapper,
  Span,
};

export default {
  styledProductOptionForm,
  styledOptionMenu,
  styledFolderStructure,
  styledOption,
};
